import timezone from 'dayjs/plugin/timezone';
const sessionStore = useSessionStore();
const dayjs = useDayjs();
dayjs.extend(timezone);
export default defineNuxtRouteMiddleware((to, from) => {
  const user = sessionStore.$state.currentUser;
  if (!user) return navigateTo('/sign-in');
  // const isExpired = dayjs.tz(new Date(), 'Asia/Jakarta').isAfter(dayjs.tz(user.token.expirationTime, 'Asia/Jakarta').format('DD/MM/YYYY HH:mm a'));
  // if (!user || isExpired) {
  //   return navigateTo('/sign-in');
  // }
});
